var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-tooltip", { attrs: { theme: "light", effect: "light" } }, [
    _c("img", {
      attrs: {
        src:
          _vm.attrs.fieldTypeText === "文本"
            ? require("@/assets/img/text.png")
            : _vm.attrs.fieldTypeText === "数值"
            ? require("@/assets/img/number.png")
            : _vm.attrs.fieldTypeText === "日期"
            ? require("@/assets/img/date.png")
            : require("@/assets/img/datetime.png"),
        alt: "",
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: { width: "200px" },
        attrs: { slot: "content" },
        slot: "content",
      },
      [
        _c("div", [_vm._v("字段类型：" + _vm._s(_vm.attrs.fieldTypeText))]),
        _vm._v(" "),
        _c("div", [
          _c("span", [_vm._v("字段属性：")]),
          _vm._v(" "),
          _vm.attrs.fieldLength
            ? _c("span", [_vm._v("长度" + _vm._s(_vm.attrs.fieldLength))])
            : _vm._e(),
          _vm._v(" "),
          _vm.attrs.fieldPrecision
            ? _c("span", [_vm._v(" 精度" + _vm._s(_vm.attrs.fieldPrecision))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("字段说明：" + _vm._s(_vm.attrs.fieldDesc || "-"))]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }